import React from 'react';

import Button from 'components/partials/button/button';

import { twMerge } from 'tailwind-merge';

interface GuidedPromptFooterProps {
  isMultiStep: boolean;
  currentStep: number;
  isLastStep: boolean;
  isRequired: boolean;
  canProceed: boolean;
  onPrevious: () => void;
  onSkip: () => void;
}

const GuidedPromptFooter = ({
  isMultiStep,
  currentStep,
  isLastStep,
  isRequired,
  canProceed,
  onPrevious,
  onSkip,
}: GuidedPromptFooterProps): React.JSX.Element => (
  <div
    className={twMerge(
      'flex items-center px-4 pt-2.5 pb-3.5 border-t border-gray-100',
      'justify-start',
      isMultiStep && 'justify-between'
    )}
  >
    <div className="flex items-center gap-3">
      {isMultiStep && currentStep > 0 && (
        <Button
          type="button"
          variant="neutral-text"
          size="sm"
          onClick={onPrevious}
        >
          Back
        </Button>
      )}
      {!isMultiStep && (
        <Button
          type="submit"
          variant="reserve-filled"
          size="sm"
          disabled={!canProceed}
          title={!canProceed ? 'Answer required to continue' : undefined}
        >
          Submit
        </Button>
      )}
    </div>

    {isMultiStep && (
      <div className="flex items-center gap-3">
        {!isRequired && !isLastStep && (
          <Button
            type="button"
            variant="neutral-text"
            size="sm"
            onClick={onSkip}
          >
            Skip
          </Button>
        )}
        <Button
          type="submit"
          variant="reserve-filled"
          size="sm"
          disabled={!canProceed}
          title={!canProceed ? 'Answer required to continue' : undefined}
        >
          {isLastStep ? 'Submit' : 'Next'}
        </Button>
      </div>
    )}
  </div>
);

export default GuidedPromptFooter;
